import React from "react"
import  { useEffect, useRef, useState } from 'react';
import {Button, Card, Col, DatePicker, Divider, Form, Input, Modal, Popconfirm, Radio, Row, Select, Space, Switch, Table, Tooltip} from 'antd'
import './pages-finance-collections.css';
import { CheckCircleOutlined, CloseCircleOutlined, RightSquareOutlined, EyeOutlined, EditOutlined, FormOutlined,SearchOutlined ,IssuesCloseOutlined} from '@ant-design/icons';
import Highlighter from 'react-highlight-words';
import moment from 'moment';
import TextArea from "antd/lib/input/TextArea";
import {CollectionsService, PurchasesProductService} from 'libs/shared-services/finance/src'
import { iceGateReq, iceGateVerification, PaymentTypeReq } from "libs/shared-models/finance/src";
import { CollectionPaymentTypes, IceGateStatus } from "@gtpl/shared-models/common-models";
import { AlertMessages } from "@gtpl/shared-utils/alert-messages";
import { PortOfEntryCodes } from "@gtpl/shared-models/sale-management";
import {  SaleOrderService } from '@gtpl/shared-services/sale-management';
export interface IceGateProps {
  tab:string
  activeTab?: string
  }
  
  export function IceGate(props: IceGateProps) {
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState<number>(100);
    const [data, setData] = useState([])
    const [searchText, setSearchText] = useState("");
    const [searchedColumn, setSearchedColumn] = useState("");
    const searchInput = useRef(null);
    const [isModalVisible,setIsModalVisible] = useState<boolean>(false)
    const { Option } = Select;
    const [form] = Form.useForm();
    const [form1] = Form.useForm();
    const [paymentModalVisible,setPaymentModalVisible] = useState<boolean>(false)
    const service = new CollectionsService()
    const [soData, setSoData] = useState<any>()
  const [fobVal, setFobVal] = useState("");
  const [netWeight, setNetWeight] = useState("");
  const [exchangeRateValue, setExchangeRateValue] = useState("");
   const [years,setYears] = useState<any[]>([])
  const invoiceDataService = new SaleOrderService;
    const [factoriesData, setFactoriesData] = useState([]);
    const purchaseService = new PurchasesProductService()
    
    useEffect(() => {
      if (!props.activeTab || props.activeTab === "1") {
        getData(props.tab)
      }
  }, [props.tab, props.activeTab])
    useEffect(() => {
      getAllFinancialYear()
      getAllCompanyNames()
  }, [props.tab])
  useEffect(() => {
    if (isModalVisible && soData) {
      form.setFieldsValue({
        shippingBillNo: soData?.shippingBillNo || '',
        shippingBillDate: soData?.shippingBillDate ? moment(soData.shippingBillDate) : null,
      });
    }
  }, [isModalVisible, soData,form]);
  const getAllFinancialYear  = () => {
    invoiceDataService.getAllFinancialYear().then(res => {
      if (res.status) {
        setYears(res.data);
      } else {
        if (res.intlCode) {
          setYears([]);
          AlertMessages.getErrorMessage(res.internalMessage);
        } else {
          AlertMessages.getErrorMessage(res.internalMessage);
        }
      }
    }).catch(err => {
      setYears([]);
      AlertMessages.getErrorMessage(err.message);
    })
  }

      const getAllCompanyNames = () => {
    purchaseService.getAllCompanys().then((res) => {
        if (res.status) {
            setFactoriesData(res.data)
        }
    })
}

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };
  const getPortName = (portOfLoading) => {
    const port = PortOfEntryCodes.find((item) => item.value === Number(portOfLoading));
    return port ? port.name : '-';
  };
  const getColumnSearchProps = (dataIndex: string) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button
          size="small"
          style={{ width: 90 }}
          onClick={() => {
            handleReset(clearFilters);
            setSearchedColumn(dataIndex);
            confirm({ closeDropdown: true });
          }}
        >
          Reset
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        type="search"
        style={{ color: filtered ? "#1890ff" : undefined }}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase())
        : false,
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current.select());
      }
    },
    render: (text) =>
      text ? (
        searchedColumn === dataIndex ? (
          <Highlighter
            highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={text.toString()}
          />
        ) : (
          text
        )
      ) : null,
  });
  const getData = (val) => {
     const req = new PaymentTypeReq(props.tab)
       
        if(form.getFieldValue('financialYear') !== undefined){
          req.financeYear = form.getFieldValue('financialYear')
        }
         if(form.getFieldValue('unit') !== undefined){
          req.unitId = form.getFieldValue('unit')
        }
 service.getShippedPoData(req).then((res)=>{
  if (res.status) {
    setData(res.data); 
  } else {
    setData([]);       
  }
}).catch((err) => {
  console.error('Error fetching data:', err);
  setData([]);
});
}
  // const data =[{
  //   invoiceNumber:'465esw'
  // }]
  const iceGate =(val) =>{
    console.log(val,'ooooooo');
    
    setFobVal(val.fob)
    setNetWeight(val.qty)
    setExchangeRateValue(val.exchangeRate)
    setSoData(val)
    setIsModalVisible(true)
    }
    const payment =(val) =>{
      console.log(val);
      
        setPaymentModalVisible(true)
        }
        const verify= async (val)=>{
          const req = new iceGateVerification(val.poNum,val.invoiceNumber,IceGateStatus.VERIFIED,val.soId,val.buyerId,val.invAmt,Number(val.unitId))
          service.iceGateVerification(req).then((res)=>{
            if(res.status){
                getData(props.tab)
     
              AlertMessages.getSuccessMessage(res.internalMessage)
            }else{
              AlertMessages.getErrorMessage(res.internalMessage)
            }
          })
        }
  const columns: any[] = [
    {
      title: 'S No', dataIndex: 'sNo', render: (text, object, index) => {
        if (index == data.length) {
          return null;
        } else {
          return index + 1
        }
      },
      width: 60,

    },
    {
        title: 'PO number', 
       width: 200,
       dataIndex: 'poNum',
 
         render: (text: any, record: any) => { return record.poNum ? record.poNum : '-' } ,
         sorter: (a, b) => a.poNum.localeCompare(b.poNum),
       sortDirections: ['descend', 'ascend'],
      ...getColumnSearchProps('poNum')},
    {
       title: 'Invoice Number', 
      width: 200,
      dataIndex: 'invoiceNumber',

        render: (text: any, record: any) => { return record.invoiceNumber ? record.invoiceNumber : '-' } ,
        sorter: (a, b) => a.invoiceNumber.localeCompare(b.invoiceNumber),
      sortDirections: ['descend', 'ascend'],
     ...getColumnSearchProps('invoiceNumber')},
     
    {
       title: 'SHIPPING BILL NO.', 
      width: 200,
      dataIndex: 'shippingBillNo',

      //   sorter: (a, b) => a.shippingBillNo.localeCompare(b.shippingBillNo),
      // sortDirections: ['descend', 'ascend'],
     },
     {
      title: 'SHIPPING BILL DATE', 
     width: 200,
     dataIndex: 'shippingBillDate',

       render: (text: any, record: any) => { return record.shippingBillDate ? moment(record.shippingBillDate).format('DD-MM-YYYY') : '-' },
    //    sorter: (a, b) => a.shippingBillDate.localeCompare(b.shippingBillDate),
    //  sortDirections: ['descend', 'ascend'],
    },
    {
       title: 'LEO DATE', 
       width: 200,
       dataIndex: 'eta',
         render: (text: any, record: any) => { return record.eta ? moment(record.eta).format('DD-MM-YYYY') : '-' },
         sorter: (a, b) => (a.eta || '').localeCompare(b.eta || ''), // safer string comparison
         sortDirections: ['descend', 'ascend'],
     },
     {
        title: 'NET WEIGHT', 
       width: 200,
       dataIndex: 'qty',
         render: (text: any, record: any) => { return record.qty ?  record.qty : '-' },
         sorter: (a, b) => (a.qty || '').localeCompare(b.qty || ''), // safer string comparison
         sortDirections: ['descend', 'ascend'],
      },
     {
      title: 'INV VALUE USD', 
     width: 200,
     dataIndex: 'invAmt',
       render: (text: any, record: any) => { return record.invAmt ?  record.invAmt : '-' },
       sorter: (a, b) => a.invAmt.localeCompare(b.invAmt),
     sortDirections: ['descend', 'ascend'],
    },
   
    {
       title: 'FOB VALUE(INR)', 
      width: 100,
      dataIndex: 'fob',

        render: (text: any, record: any) => { return record.fob ? (Number(record.exchangeRate) * Number(record.fob)).toFixed(2) : '-' },
        sorter: (a, b) => a.fob.localeCompare(b.fob),
      sortDirections: ['descend', 'ascend'],
    //  ...getColumnSearchProps('qtyStock')
     },
     {
      title: 'RODTEP Value(INR)', 
     width: 100,
     dataIndex: 'fob',

       render: (text: any, record: any) => { 
        console.log(Number(record.exchangeRate),'inr value');
        
        return record.fob ?   Number(Math.min(0.033*Number(record.exchangeRate) * Number(record.fob), 42*Number(record.qty))).toFixed(2):'-'},
       sorter: (a, b) => a.fob.localeCompare(b.fob),
     sortDirections: ['descend', 'ascend'],
   //  ...getColumnSearchProps('qtyStock')
    },
     {
        title: 'Buyer', 
       width: 200,
       dataIndex: 'buyer',
         render: (text: any, record: any) => { return record.buyer ?  record.buyer : '-' },
         sorter: (a, b) => a.buyer.localeCompare(b.buyer),
       sortDirections: ['descend', 'ascend'],
      },
    {
        title: 'CHA', 
       width: 100,
       dataIndex: 'cha',
 
         render: (text: any, record: any) => { return record.cha ? record.cha : '-' },
      //    sorter: (a, b) => a.cha.localeCompare(b.cha),
      //  sortDirections: ['descend', 'ascend'],
     //  ...getColumnSearchProps('qtyStock')
      },
      {
        title: 'Port Code',
        dataIndex: 'port',
        // render: (text, record) => {record.port ?PortOfEntryInput.find((e)=>e.value ===record.port).name : "-"},
   render: (text, record) => getPortName(record.port),  
                   width:"50px"
      },
      {
        title: `Ice Gate Verification`,
        dataIndex: 'iceGateStatus',
        fixed: 'right',
        render: (text, rowData) => {
          console.log(rowData,"ddd")
        return(
            <>
 <Popconfirm 
            title={
              rowData.iceGateStatus===  IceGateStatus.VERIFIED
                ? 'Are you sure to UnVerify Ice Gate ?'
                :  'Are you sure to Verify Ice Gate ?'
            }
            onConfirm={ e =>{verify(rowData);}}
          >              <Switch 
              size="default"
              checkedChildren={<RightSquareOutlined />}
              unCheckedChildren={<RightSquareOutlined />}
              checked={rowData.iceGateStatus === IceGateStatus.VERIFIED}
              disabled={rowData.iceGateStatus === IceGateStatus.VERIFIED}
             
              />
              </Popconfirm>
              </> )
       }
      },
     {
        title: `Ice Gate Update`,
        dataIndex: 'action',
        fixed: 'right',
        render: (text, rowData) => {
        return(
            <>
            <Button  onClick={() => iceGate(rowData)} disabled={rowData.iceGateStatus != IceGateStatus.VERIFIED}>
           <FormOutlined title="Update" style={{ color: 'green' }}/>
           </Button>
            </> )
       }
      },
      // {
      //   title: `Payment Update`,
      //   dataIndex: 'action',
      //   fixed: 'right',
      //   render: (text, rowData) => {
      //   return(
      //       <><FormOutlined title="Not Update" style={{ color: 'red' }} onClick={() => console.log('not update')} />
      //       <Divider/>
      //       <FormOutlined title="Update" style={{ color: 'green' }} onClick={() => payment(rowData)} />
      //       </> )
      //  }
      // }
     
  ]
  let createdUser="";
  // let unitId = localStorage.getItem("unit_id")

  const cancel = () =>{
    setIsModalVisible(false)
    form.resetFields()
  }
 
  const save = (val) =>{
    console.log(val,'ppppppppp');
    
    const req = new iceGateReq(val.scrollNo,val.scrollDate,createdUser,Number(soData.unitId),val.rodtep,CollectionPaymentTypes.RODTEP,soData.buyerId,soData.soId,soData.invoiceNumber,soData.poNum,soData.eta,val.shippingBillNo,val.shippingBillDate)
    service.iceGateUpdate(req).then((res)=>{
      if(res.status){
        AlertMessages.getSuccessMessage(res.internalMessage)
        // console.log('oooooooooooooooooooooooooftrgc');
        form.resetFields()
        setIsModalVisible(false)
        getData(props.tab)
      }
    })
  }

  let fobCalculation
  fobCalculation = Number(Math.min(0.033 * Number(fobVal), 42*Number(netWeight))).toFixed(2)
  //  console.log(0.033 * Number(fobVal),4.2*Number(netWeight),Number(Math.min(0.033 * Number(fobVal), 4.2*Number(netWeight))).toFixed(2),'poooooooo');
  const search =() =>{
    getData(props.tab)
   }
   const onReset = () => {
    form.resetFields();
  }
    return (
        <>
        <Form form={form} onFinish={search}>
                              <Row gutter={24}>
                                 <Col xs={{span:24}} sm={{span:24}} md={{span:6}} lg={{span:6}} xl={{span:6}}>
                   <Form.Item name="unit" label="Unit" rules={[{ required: false }]}>
                          <Select
                              showSearch
                              optionFilterProp="children"
                              filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                              placeholder=" Select Unit"
                              allowClear
                              dropdownMatchSelectWidth={false}
                          >
                                {factoriesData.map(dropData => {
                                  console.log(factoriesData,'factoriesDatafactoriesDatafactoriesData')
                                  return <Option value={dropData.companyId}>{dropData.company}</Option>
                              })}
                          </Select>
                          </Form.Item>
      
      
      
                          </Col >
                                  <Col xs={24} sm={12} md={6} lg={6} xl={6}>
                      <Form.Item name="financialYear" label="Financial Year">
                        <Select
                          showSearch
                          placeholder="Select Financial Year"
                          optionFilterProp="children"
                          allowClear
                        >
                          {years.filter(year => year.financialYear !== null).map((y: any) => (
                            <Select.Option key={y.financialYear} value={y.financialYear}>
                              {y.financialYear}
                            </Select.Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                                  <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5 }} lg={{ span: 5 }} xl={{ span: 5 }}>
                                                                           <Form.Item>
                                                               <Space>
                                                                 <Button type="primary" htmlType="submit">
                                                                   Search
                                                                 </Button>
                                                                 <Button type="primary" htmlType="reset" onClick={() => onReset()}>
                                                                   Reset
                                                                 </Button>
                                                               </Space>
                                                             </Form.Item>
                                                                           </Col>
                              </Row>
                          </Form>
        <Table columns={columns} dataSource={data} scroll={{x:"max-content"}}/>
        <Modal width={'90%'} footer={null} visible={isModalVisible} style={{ background: '#69c0ff', textAlign: 'center', color: 'white' }} 
            onCancel={cancel}>
            <Card size="small" title={`Ice Gate (To Be Receive : ${fobVal?  Number(Math.min(0.033 *Number(exchangeRateValue)* Number(fobVal), 4.2*Number(netWeight))).toFixed(2):'-'})`}
            
            // title={<span style={{ color: 'white' }} >Ice Gate</span>}
            style={{ textAlign: 'center' }} headStyle={{ backgroundColor: '#69c0ff', border: 0 }}
            >
                <Form form={form} onFinish={save}>
                    <Row gutter={24}>
                        
               <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5 }} lg={{ span: 6 }} xl={{ span: 8 }}>
                        <Form.Item label='SHIPPING BILL NO' name='shippingBillNo' rules={[{ required: true, message: 'Missing Shipping Bill No' }]}>
                              <Input placeholder="Enter Shipping Bill No"  />
                            </Form.Item>
                        </Col>
                        <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5 }} lg={{ span: 6 }} xl={{ span: 8 }}>
                        <Form.Item label='SHIPPING BILL Date' name='shippingBillDate' rules={[{ required: false, message: 'Missing Shipping Date' }]}>
                        <DatePicker style={{width:'100%'}}/>
                        </Form.Item>
                        </Col> 
                              
               <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5 }} lg={{ span: 6 }} xl={{ span: 8 }}>
                        <Form.Item label='SCROLL NO' name='scrollNo' rules={[{ required: true, message: 'Missing Scroll No' }]}>
                              <Input placeholder="Enter Scroll No"  />
                            </Form.Item>
                        </Col>
                        <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5 }} lg={{ span: 6 }} xl={{ span: 8 }}>
                        <Form.Item label='SCROLL Date' name='scrollDate' rules={[{ required: true, message: 'Missing Scroll Date' }]}>
                        <DatePicker style={{width:'100%'}}/>
                        </Form.Item>
                        </Col> 
                        <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5 }} lg={{ span: 6 }} xl={{ span: 8 }}>
                                  <Form.Item label='RECEIVED AMOUNT' name='rodtep' rules={[
                            { required: true, message: "Missing Received Amount" },
                            // ({ getFieldValue }) => ({
                            //   validator(_, value) {
                            //     if (!value || parseFloat(value) <= parseFloat(fobCalculation)) {
                            //       return Promise.resolve();
                            //     }
                            //     return Promise.reject(new Error("Received Amount cannot be greater than payment"));
                            //   },
                            // }),
                          ]} >
                                        <Input placeholder="Enter Amount"  />
                                      </Form.Item>
                                  </Col>     
                        {/* <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5 }} lg={{ span: 6 }} xl={{ span: 8 }}>
                            <Form.Item label='RODTEP (as per Ice Gate )' name='rodtep'>
                                <Input placeholder="Enter RODTEP Payment" />
                            </Form.Item>
                        </Col> */}
                        
                    </Row>
                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5 }} lg={{ span: 5 }} xl={{ span: 5 }}>
                        <Form.Item>
                            <Button type='primary' htmlType='submit'>Submit</Button>
                        </Form.Item>
                    </Col>
                </Form>
            </Card>
        </Modal>
        {/* <Modal width={'90%'} footer={null} visible={paymentModalVisible} style={{ background: '#69c0ff', textAlign: 'center', color: 'white' }} 
            onCancel={onCancel}>
            <Card>
                <Form form={form1} onFinish={savePayment}>
                    <Row gutter={24}>
                        
                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5 }} lg={{ span: 6 }} xl={{ span: 8 }}>
          <Form.Item label='IRM NO' name='irmNo' rules={[{ required: true, message: 'Missing IRM No' }]}>
                <Input placeholder="Enter IRM NO"  />
              </Form.Item>
          </Col>
                              
                    </Row>
                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5 }} lg={{ span: 5 }} xl={{ span: 5 }}>
                        <Form.Item>
                            <Button type='primary' htmlType='submit'>Submit</Button>
                        </Form.Item>
                    </Col>
                </Form>
            </Card>
        </Modal> */}
        </>
    )
  }
  export default IceGate
   
